import React from "react";
import IndustriesBannerImage1 from "../../images/Hero-Banner-Retail-rapidfresh.png";
import IndustriesBannerImage2 from "../../images/Hero-Banner-Retail-rapidshop.png";
import IndustriesBannerImage3 from "../../images/Hero-Banner-Retail.jpg";
import SegmentSliderImage1 from "../../images/Grocery-Retailers.jpg";
import SegmentSliderImage2 from "../../images/Direct-To-Consumer.jpg";
import SegmentSliderImage3 from "../../images/Department-Stores.jpg";
import SegmentSliderImage4 from "../../images/Online-Retailers.jpg";

import IconEnableOmnichannelShopping from "../../icons/icon-Enable-Omnichannel-Shopping.svg";
import IconDigitizeFreshFoodCommerce from "../../icons/icon-Digitize-Fresh-Food-Commerce.svg";
import IconEnterpriseB2CeCommerce from "../../icons/icon-Enterprise-B2C-eCommerce.svg";
import IconEnterpriseB2BeCommerce from "../../icons/icon-Enterprise-B2B-eCommerce.svg";
import IconHeadlessDragDropCMS from "../../icons/icon-Headless-DragDrop-CMS.svg";
import IconDeliverExceptionSupport from "../../icons/icon-Deliver-Exception-Support.svg";

import ImageOutStockDetection from "../../images/Out-Of-Stock-Detection.jpg";
import ImageDeliverPersonalizedExperiences from "../../images/Deliver-Personalized-Experiences.jpg";
import ImageMonetizeCrossOpportunities from "../../images/Monetize-Cross-Sell.jpg";
import ImageInventoryOptimization from "../../images/Inventory-Optimization-Retail.jpg";
import ImageSupplychainOptimization from "../../images/Supply-Chain.jpg";

import ImageUseCase1 from "../../images/Last-Mile-Delivery-Automation.jpg";
import ImageUseCase2 from "../../images/Scan-Go-Mobile-Checkout.jpg";
import ImageUseCase3 from "../../images/Shoppable-Recipes.jpg";
import ImageUseCase4 from "../../images/Curbside-Pick-Up.jpg";
import ImageUseCase5 from "../../images/Customer-Loyalty-Program.jpg";
import ImageUseCase6 from "../../images/Omnichannel-Experiences.jpg";
import ImageUseCase7 from "../../images/Dark-Stores.jpg";
import ImageUseCase8 from "../../images/In-Store-Product-Locator.jpg";
import ImageUseCase9 from "../../images/Digital-Pharmacy.jpg";

import IconDataAnalytics from "../../icons/icon-retail-data-analytics.svg";
import IconEnterpriseIntegrations from "../../icons/icon-retail-enterprise-integrations.svg";
import IconCloudEnablement from "../../icons/icon-retail-cloud-enablement.svg";
import IconDigitalStrategy from "../../icons/icon-transformation-strategy-roadmap-ps.svg";
import IconDigitalExperiences from "../../icons/icon-retail-digital-experiences.svg";
import IconDigitalTransformation from "../../icons/icon-retail-digital-transformation.svg";

import ImageCSslider1 from "../../images/01.jpg";
import ImageCSslider2 from "../../images/02.jpg";
import ImageCSslider3 from "../../images/03.jpg";
import ImageCSslider4 from "../../images/04.jpg";

import ImageBlogImage1 from "../../images/retail-blog-img-1.png";
import ImageBlogImage2 from "../../images/retail-blog-img-2.jpg";

export const mainBannerObj = {
  classes: "industries-banner industries-retail-banner",
  title: "Retail Industries",
  mediaType: "image",
  mediaSource: IndustriesBannerImage3,
  mediaClass: "",
  imagetitle: "Ecommerce Products and Services",
  imagealt: "Ecommerce Products and Services",
  bannerItems: [
    {
      subheader:"DATASHEET - RAPIDFRESH",
      header: (<>Unlock Fresh Food &  <br /> Deli Experience</>),
      content: <>rapidFRESH is an end-to-end fresh food and grocery platform to enable your AI-powered, modern, and hyper-personalized shopping experience for your customers. </>,
      buttonText:"Download",
      link: "/platform/rapidfresh/",
    },
    {
      subheader:"DATASHEET - RAPIDSHOP",
      header: (<>Enable Omnichannel<br/> Shopping Experiences</>),
      content: <>rapidSHOP - a one-stop retail solution to enable your AI-powered, modern, and hyper-personalized omnichannel shopping experience for your customers.</>,
      buttonText:"Download",
      link: "/platform/rapidshop/",
    },
    {
      subheader:"STRATEGY",
      header: (<>Recreate the <br /> in-store customer <br /> experience</>),
      content: <>Discover why is in-store experience important while <br /> developing a digital retail strategy?</>,
      buttonText:"Read More",
      link: "/blog/in-store-experience-while-developing-digital-retail-strategy/"
    }
  ],
  bannerSliderImageItems: [
    {
      image: IndustriesBannerImage1,
      imagetitle: "Industries Retail - RAPIDFRESH",
      imagealt: "Industries Retail- RAPIDFRESH",
    },
    {
      image: IndustriesBannerImage2,
      imagetitle: "Industries Retail - RAPIDSHOP",
      imagealt: "Industries Retail - RAPIDSHOP",
    },
    {
      image: IndustriesBannerImage3,
      imagetitle: "Industries Retail",
      imagealt: "Industries Retail",
    }
  ]
};

export const pageIntroObj = {
  classes: "section-gap retail-intro",
  title: "Embracing the digital disruption",
  header: (<>Digital revolution is pushing businesses of every size and shape <br /> in all industries to reimagine their strategy and growth.</>),
  content: (<><p>Consumer expectations for digital shopping have been hitting a steady streak for years, but most brick and mortar retailers were still early in establishing their digital shopping and delivery services. However, the pandemic has changed traditional retail forever and unleashed the entire decade’s digital transformation in less than a year. 72% of consumers have grown their appetite and need for online and contactless shopping. Retailers have no choice but to enable digital shopping and personalized experiences unprecedentedly to survive and thrive in the new world.<br/><br/> At the forefront of retail and technology, Rapidops helps retailers to invent their digital future where innovation, automation, and experience are vital to lead and succeed. Our products and services enable retailers to quickly launch omnichannel and personalized retail experiences that exceed consumer expectations, drive loyalty, and unlock new avenues for revenue growth.</p></>)
};

export const industrySegmentsObj = {
  classes: "section-gap industry-segment",
  title: "Retail industry",
  header: (<>Industry Segments</>),
  content: (<><p>Unleashing the growth potential of retailers in different segments with digital, data, and design across various industry segments</p></>),
  segmentSliderItems: [
    {
      image: SegmentSliderImage1,
      imagetitle: "Grocery Retailers",
      imagealt: "Grocery Retailers",
      header: (<>Grocery Retailers</>),
      content: <>Implement new business models to keep pace with shifting consumer behavior and better manage the supply chain and delivery.</>,
    },
    {
      image: SegmentSliderImage2,
      imagetitle: "Direct to Consumer",
      imagealt: "Direct to Consumer",
      header: (<>Direct to Consumer</>),
      content: <>Develop the right platforms and digital strategy to own direct customer relationships with outstanding experiences and ROI.</>,
    },
    {
      image: SegmentSliderImage3,
      imagetitle: "Department Stores",
      imagealt: "Department Stores",
      header: (<>Department Stores</>),
      content: <>Leverage technology to provide a personalized shopping experience and meet the changing demand of digital-savvy customers.</>,
    },
    {
      image: SegmentSliderImage4,
      imagetitle: "Online Retailers",
      imagealt: "Online Retailers",
      header: (<>Online Retailers</>),
      content: <>Create hyper-personalized experiences and take your online retail business to the next level.</>,
    },
  ]
};

export const threeColSliderObj = {
  classes: "retail-solution",
  header: <>Retail Products</>,
  content: <>Out-of-the-box products and platforms that help retailers lead the digital disruption <br/> driven by consumers and new normal.</>,
  items: [
    {
      icon: <IconEnableOmnichannelShopping />,
      subHeader: "rapidSHOP",
      header: "Enable Omnichannel Shopping",
      link: "/platform/rapidshop/",
      content: "Create seamless and personalized shopping experiences across web, mobile, and stores with our end-to-end digital ordering, fullfilment, and analytics solution for grocery retailers."
    }, {
      icon: <IconDigitizeFreshFoodCommerce />,
      subHeader: "rapidFRESH",
      header: "Digitize the Fresh Food Commerce",
      link: "/platform/rapidfresh/",
      content: "Generate more revenue for your fresh food departments such as deli, meat shop, bakery with a complete solution for online ordering, fulfillment, pick-up, and delivery."
    }, {
      icon: <IconEnterpriseB2CeCommerce />,
      subHeader: "rapidCOMM/B2C",
      header: "Enterprise B2C eCommerce",
      link: "",
      content: "Boost your sales with our unified, secure, and modern B2C eCommerce platform that connects your business with consumers anywhere and anytime."
    }, {
      icon: <IconEnterpriseB2BeCommerce />,
      subHeader: "rapidCOMM/B2B",
      header: "Enterprise B2B eCommerce",
      link: "",
      content: "Create seamless and self-service B2B shopping experiences that drive growth, loyalty, and operational efficiencies to take your business to new heights."
    }, {
      icon: <IconHeadlessDragDropCMS />,
      subHeader: "rapidCMS",
      header: "Headless & Drag-n-Drop CMS",
      link: "",
      content: "Create and deliver engaging content experiences across web, mobile, and emails with a fast, code-free, and multi-channel content management system."
    }, {
      icon: <IconDeliverExceptionSupport />,
      subHeader: "rapidCHAT",
      header: "Deliver Exception Support",
      link: "",
      content: "Deliver fast, friendly, and automated conversational experiences for sales and support using purpose-built chat automation software."
    }
  ]
};


export const industryRetailAIObj = {
  title: "Retail AI",
  content: "Use power of data and AI to unlock new growth opportunities.",
  tabItems: [
    {
      header: "Out-of-stock Detection",
      link: "/services/digital-product/"
    }, {
      header: "Deliver Personalized Experiences",
      link: "/services/digital-transformation/"
    }, {
      header: "Monetize Cross-sell & Up-sell Opportunities",
      link: "/services/data-analytics/"
    }, {
      header: "Inventory Optimization",
      link: "/services/data-analytics/"
    }, {
      header: "Supply-chain Optimization",
      link: "/services/data-analytics/"
    },
  ],
  serviceMediaOne: [
    {
      source: ImageOutStockDetection,
      imagetitle: "Out of Stock Detection",
      imagealt: "Out of Stock Detection",
      content: "Leverage the power of AI to eliminate the need to check shelves, prevent lost sales opportunities, and halt customer complaints due to out-of-stock items by keeping the shelves filled.",
    }
  ],
  serviceMediaTwo: [
    {
      source: ImageDeliverPersonalizedExperiences,
      imagetitle: "Deliver Personalized Experiences",
      imagealt: "Deliver Personalized Experiences",
      content: "Rapidops help retailers with a next-gen foundation to enable omnichannel eCommerce, personalized shopping and delivery services in a matter of months.",
    }
  ],
  serviceMediaThree: [
    {
      source: ImageMonetizeCrossOpportunities,
      imagetitle: "Cross Sell Opportunities",
      imagealt: "Cross Sell Opportunities",
      content: "Unleash the power of on-demand shopping experiences to improve sales with offers, complementary products, and promotions as customers shop at stores or apps.",
    },
  ],
  serviceMediaFour: [
    {
      source: ImageInventoryOptimization,
      imagetitle: "Inventory Optimization",
      imagealt: "Inventory Optimization",
      content: "Avoid overstocks, product obsolescence, and lost sales and achieve intelligent forecasts that represent the actual demand using predictive data analytics.",
    },
  ],
  serviceMediaFive: [
    {
      source: ImageSupplychainOptimization,
      imagetitle: "Supply Chain Optimization",
      imagealt: "Supply Chain Optimization",
      content: "Improve operational margins and customer experiences by optimizing order fullfilments using AI-powered technologies to automate order picking, order routing, drone deliveries, and much more.",
    },
  ]
};


export const useCaseObj = {
  classes: "reatail-usecase",
  header: (<>Retail Solutions</>),
  content: (<><p>Enabling retail businesses to survive and thrive in the digital age</p></>),
  useCaseItems: [
    {
      image: ImageUseCase1,
      imagetitle: "Last-mile Delivery Automation",
      imagealt: "Last-mile Delivery Automation",
      title: (<>Last-mile Delivery Automation</>),
      content: <>Deliver products at your customers' doorstep with an end-to-end fulfillment and delivery solution.</>,
    },
    {
      image: ImageUseCase2,
      imagetitle: "Scan & Go Mobile Checkout",
      imagealt: "Scan & Go Mobile Checkout",
      title: (<>Scan & Go Mobile Checkout</>),
      content: <>Reduce the checkout queues and costs at the store by enabling customers to shop and pay from their phones.</>,
    },
    {
      image: ImageUseCase3,
      imagetitle: "Shoppable Recipes",
      imagealt: "Shoppable Recipes",
      title: (<>Shoppable Recipes</>),
      content: <>Enable new shopping behaviors by letting customers shop all ingredients required in a recipe with a single click.</>,
    },
    {
      image: ImageUseCase4,
      imagetitle: "Curbside Pick-up",
      imagealt: "Curbside Pick-up",
      title: (<>Curbside Pick-up</>),
      content: <>Allow customers to place the order online, enable store staff to prepare the order quickly, and hand it to the customers at the curbside.</>,
    },
    {
      image: ImageUseCase5,
      imagetitle: "Customer Loyalty Program",
      imagealt: "Customer Loyalty Program",
      title: (<>Customer Loyalty Program</>),
      content: <>Roll out your own multi-channel loyalty program that improves retention and creates customers for life.</>,
    },
    {
      image: ImageUseCase6,
      imagetitle: "Omnichannel Experiences",
      imagealt: "Omnichannel Experiences",
      title: (<>Omnichannel Experiences</>),
      content: <>Enable omnichannel  experiences for each customer to drive digital sales across all channels while growing sales.</>,
    },
    {
      image: ImageUseCase7,
      imagetitle: "Dark Stores",
      imagealt: "Dark Stores",
      title: (<>Dark Stores</>),
      content: <>Automate order fulfillment and optimize store efficiency with real-time inventory management and delivery solution.</>,
    },
    {
      image: ImageUseCase8,
      imagetitle: "In-store Product Locator",
      imagealt: "In-store Product Locator",
      title: (<>In-store Product Locator</>),
      content: <>Help your customers find the right products quickly with guided in-store navigation and aisle locator.</>,
    },
    {
      image: ImageUseCase9,
      imagetitle: "Digital Pharmacy",
      imagealt: "Digital Pharmacy",
      title: (<>Digital Pharmacy</>),
      content: <>Create a positive, seamless customer experience by making your digital pharmacy ready for modern customer journey.</>,
    },
  ]
};

export const gridlayoutObj = {
  classes: "two-row-three-col-grid",
  header: "Services",
  subHeader: "Our tailor-made solutions and services to help you monetize digital opportunities",
  gridItems: [
    {
      icon: <IconDataAnalytics />,
      header: "Data Analytics",
      content: "Deliver rich data-driven insights and experiences across products and customers with analytics and AI"
    },
    {
      icon: <IconEnterpriseIntegrations />,
      header: "Enterprise Integrations",
      content: "Integrate and orchestrate the silo’ed internal and external systems to reduce costs and create digital sales channels"
    },
    {
      icon: <IconCloudEnablement />,
      header: "Cloud Enablement",
      content: "Create automated and cost-effective technology infrastructure on public (GCP, Azure, AWS) or private clouds"
    },
    {
      icon: <IconDigitalStrategy />,
      header: "Digital Strategy",
      content: "Discover and monetize digital opportunities with a proven strategy and battle-tested approach"
    },
    {
      icon: <IconDigitalExperiences />,
      header: "Digital Experiences",
      content: "Launch stunning and personalized shopping, service, and engagement experiences for all customers"
    },
    {
      icon: <IconDigitalTransformation />,
      header: "Digital Transformation",
      content: "Beat the competition and lead the market by transforming your business with technology, design, and data"
    }
  ]
};

export const CSSliderObj = {
  classes: "section-gap cs-sldier",
  csSliderItems: [
    {
      image: ImageCSslider1,
      imagetitle: "Reimagined Grocery Shopping",
      imagealt: "Reimagined Grocery Shopping",
      category: "Retail",
      header: (<>A fresh take on online grocery shopping</>),
      content: <>How did we help our client transform their business with digital retail and omnichannel experiences.?</>,
      link: "/work/harris-teeter-online-grocery-shopping/",
    },
    {
      image: ImageCSslider2,
      imagetitle: "Voice Enable Grocery Shopping",
      imagealt: "Voice Enable Grocery Shopping",
      category: "Retail",
      header: (<>Grocery shopping with your voice-assistant </>),
      content: <>How we helped a US retail giant deliver hands-free shopping experiences?</>,
      link: "/work/kroger-grocery-shopping-voice-assistant/",
    },
    {
      image: ImageCSslider3,
      imagetitle: "Transforming grocery shopping",
      imagealt: "Transforming grocery shopping",
      category: "rapidSHOP",
      header: (<>Transforming Grocery Shopping</>),
      content: <>Enabling omnichannel shopping experiences at a leading US grocery retailer with rapidSHOP.</>,
      link: "/resources/rapidSHOPCASESTUDY.pdf",
    },
    {
      image: ImageCSslider4,
      imagetitle: "Digitizing Fresh Food",
      imagealt: "Digitizing Fresh Food",
      category: "rapidFresh",
      header: (<>Digitizing Fresh Food & Deli</>),
      content: <>Unlocking new growth opportunities for fresh food and deli sales with rapidFRESH.</>,
      link: "/resources/rapidFRESHCASESTUDY.pdf",
    },
  ]
};


export const digitalThinkingobj = {
  classes: "digital-thinking",
  header: (<>Retail Thinking</>),
  content: (<><p>Our experts discuss strategies for navigating the retail landscape</p></>),
  blogGridItems: [
    { 
      width: "one-third",
      backgroundColor: "#F8F8F8",
      image: "",
      color: "black",
      category: "Analytics",
      categoryColor: "#999999",
      title: (<>Retail Analytics 2021: An insight into AI-driven retail future</>),
      link: "/blog/retail-analytics-2021-an-insight-into-ai-driven-retail-future/"
    },
    { 
      width: "one-third",
      backgroundColor: "#000000",
      image: ImageBlogImage1,
      imagealt: "AI In Retail",
      imagetitle: "AI In Retail",
      color: "white",
      category: "Strategy",
      categoryColor: "#fff",
      title: (<>How artificial intelligence is disrupting the retail industry’s future?</>),
      link: "/blog/artificial-intelligence-disrupting-the-retai-future/"
    },
    { 
      width: "one-third green-bg",
      backgroundColor: "#00D664",
      image: "",
      color: "black",
      category: "Strategy",
      categoryColor: "#333",
      title: (<>Curbside Pickup – A right option for local retailers</>),
      link: "/blog/curbside-pickup-a-right-option-for-local-retailers/"
    },
    { 
      width: "half with-img",
      backgroundColor: "transparent",
      image: ImageBlogImage2,
      imagealt: "Retail Trends",
      imagetitle: "Retail trends and insights",
      color: "white",
      category: "Ideas",
      categoryColor: "#fff",
      title: (<>8 innovative retail trends and insights to consider in 2021 and beyond</>),
      link: "/blog/innovative-retail-trends-insights/"
    },
    { 
      width: "half without-img",
      backgroundColor: "linear-gradient(0deg, #F8F8F8, #F8F8F8), #F8F8F8",
      image: "",
      color: "black",
      category: "Ideas",
      categoryColor: "#999999",
      title: (<>How digital transformation is beneficial to keep the Covid-19 pandemic in check?</>),
      link: "/blog/how-digital-transformation-is-beneficial-to-keep-the-covid-19-pandemic-in-check/"
    },
  ],
  header1: (<>Proven results in weeks, not years.</>),
  content1: (<><p>With our proven approach and expertise for digital retail, Rapidops can transform your vision into measurable success in days and weeks.</p></>),
};